import styled from 'styled-components'
import { Heading, Paragraph } from '../../atoms/Typography/Typography.styles'
import { scaleIn } from '../../../theme/animations'

export { FadeSlideUp } from '../../../theme/animations'

interface ComposableFormProps {
  colorScheme?: string;
  withBackground?: boolean;
}

export const ComposableForm = styled.div<ComposableFormProps>`
  width: 100%;
  background-color: ${({ theme, colorScheme, withBackground }) => withBackground ? theme.colorScheme[`${colorScheme}`].surface.outside : 'transparent'};
  padding: ${({ theme }) => theme.rem(32, 0)};

  ${Paragraph},
  ${Heading} {
    color: ${({ theme, colorScheme, withBackground }) => withBackground ? theme.colorScheme[`${colorScheme}`].surface.text.base.negative : 'black'};
  }
`

export const FormWrapper = styled.form`
  width: 100%;
`

export const FieldWrapper = styled.div<{ $hidden?: boolean }>`
  padding-bottom: ${({ theme, $hidden }) => $hidden ? 0 : theme.rem(24)};
`

export const SubmitWrapper = styled.div`
  padding-top: ${({ theme }) => theme.rem(16)};
`

export const CheckCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ theme }) => theme.rem(80)};
  height: ${({ theme }) => theme.rem(80)};
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.greenHill['400']};
  animation: ${scaleIn} 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
  opacity: 0;
`

export const SuccessMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: ${({ theme }) => theme.rem(64, 0)};
  width: 100%;
`

export const ErrorMessage = styled.div`
  ${Paragraph} {
    padding-top: ${({ theme }) => theme.rem(16)};
    color: ${({ theme }) => theme.palette.red['50']};
  }
`